import React, { Component } from "react";
import { Helmet } from "react-helmet";

import "./assets/style.scss";
import "./assets/style_mobile.scss";

import Hero from "./components/hero";
import Products from "./components/products";
import Roster from "./components/roster";

export default class Introduction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>ABOSS - Software for artists, agents and managers</title>
          <meta
            name="description"
            content="ABOSS - Software for artists, agents and managers"
          />
        </Helmet>
        <div className="aboss__intro-head">
          <div className="aboss__intro-head-container"></div>
        </div>
        <Hero />
        <Products />
        <Roster />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/introduction/index.js